/** Lowercases and strips accents for participant name/document search matching. */
export function foldParticipanteBusquedaText(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '');
}
